import EventsFallback from '../../../../lib/events_fallback';

namespace('IO.Views.Components.Rje.Api', function (exports) {
  exports.Management = class Management extends EventsFallback {
    constructor(...args) {
      super(...args);
      this.csrf = options.csrf;
    }

    enable(url) {
      var req = this._makePutRequest(url);

      req.done(_.bind(this._enableDoneCallback, this));
      req.fail(_.bind(this._enableFailCallback, this));
    }

    _enableDoneCallback(resp) {
      if (resp.statuscode === 0) {
        this.trigger('enable:success', {
          enabled: true,
        });
      } else {
        this._enableFailCallback(resp);
      }
    }

    _enableFailCallback(resp) {
      this.trigger('enable:fail', resp);
    }

    disable(url, data) {
      var req = this._makePutRequest(url, data);

      req.done(_.bind(this._disableDoneCallback, this));
      req.fail(_.bind(this._disableFailCallback, this));
    }

    _disableDoneCallback(resp) {
      if (resp.statuscode === 0) {
        this.trigger('disable:success', {
          enabled: false,
        });
      } else {
        this._disableFailCallback(resp);
      }
    }

    _disableFailCallback(resp) {
      this.trigger('disable:fail', resp);
    }

    _makePutRequest(url, data) {
      var additionalParams = data || {};

      return $.ajax({
        type: 'post',
        url: url,
        data: $.extend(
          {},
          {
            _method: 'put',
            authenticity_token: this.csrf,
          },
          additionalParams,
        ),
      });
    }
  };
});
